// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1846":"e023e5e0","6627":"e023e5e0","9682":"45f22c20","9860":"e023e5e0"}[chunkId] + ".chunk.css";
};